const RECOVERY_INVOICE_RETRY_MODAL_PROPS = {
  description: 'Enter a new card to retry your overdue payment and restore your subscription.',
  submitLabel: 'Add & Retry Payment',
} as const;

export { RECOVERY_INVOICE_RETRY_MODAL_PROPS };
